//#region frontend/islands/shiny-button.js
var ShinyButton = class extends HTMLElement {
	connectedCallback() {
		this._button = this.querySelector("button");
		this._onEnter = () => {
			const shimmer = document.createElement("span");
			shimmer.classList.add("shimmer");
			shimmer.style.animationDuration = `800ms`;
			shimmer.style.animationDelay = `250ms`;
			shimmer.style.animationFillMode = "both";
			shimmer.style.opacity = .2;
			this._button.appendChild(shimmer);
			setTimeout(() => shimmer.remove(), 1250);
		};
		this._button.addEventListener("mouseenter", this._onEnter);
	}
	disconnectedCallback() {
		this._button?.removeEventListener("mouseenter", this._onEnter);
	}
};
window.customElements.define("shiny-button", ShinyButton);
//#endregion
